import gql from 'graphql-tag';

import { MEDIAREF } from './AssetLibrary';
import { THEME_SETTINGS_FRAGMENT } from './ThemeSettings';

export const GDPR_SETTINGS_FRAGMENT = gql`
  fragment GdprSettings on GdprSettings {
    bannerMode
    bannerText
    bannerCode
  }
`;

export const TEAM_SETTINGS_FRAGMENT = gql`
  fragment TeamSettings on TeamSettings {
    language
    hideBranding
    requireSSOLogin
    gdpr {
      ...GdprSettings
    }
  }
  ${GDPR_SETTINGS_FRAGMENT}
`;

export const PUBLIC_TEAM_FRAGMENT = gql`
  fragment PublicTeam on Team {
    id
    name
    logoMediaRef {
      ...MediaRef
    }
    timezone
    subdomain
    domain
    isDomainVerified
    shareUrl
    themeSettings {
      ...ThemeSettings
    }
    settings {
      ...TeamSettings
    }
  }
  ${MEDIAREF}
  ${TEAM_SETTINGS_FRAGMENT}
  ${THEME_SETTINGS_FRAGMENT}
`;

export const TEAM_FRAGMENT = gql`
  fragment Team on Team {
    ...PublicTeam
    subscriptionStatus
    subscriptionSubstatus
    trialEndingDate
    timezone
    createdAt
    brandingPromoterId
    registrantLimit {
      limit
      registrants
      isFull
      registrantsLeftPercent
      includedLimit
      additionalLimit
      purchasedAdditionalLimit
      resetAt
      isTrialing
    }
  }
  ${PUBLIC_TEAM_FRAGMENT}
`;

export const TEAM_DOMAIN_SETTINGS_FRAGMENT = gql`
  fragment TeamDomainSettings on Team {
    id
    subdomain
    domain
    canonicalDomain
    isDomainVerifiedAndWorks
  }
`;
